import {
  Box,
  Grid,
  Paper,
  Button,
  useTheme,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { ContactUsStyles } from "../Styles";
import Heading from "../../components/Heading";
import { getMeaning } from "../../utils/localization";
import { ReImagineStyles } from "../../components/Styles";
import React, { useEffect, useRef, useState } from "react";
import GlobalSubHeading from "../../components/GlobalSubHeading";

const ContactUs = () => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));
  const formRef = useRef(null);
  const [formHeight, setFormHeight] = useState(600);
  useEffect(() => {
    if (formRef.current) {
      setFormHeight(formRef.current.offsetHeight);
    }
  }, []);

  return (
    <Box mb={4} sx={[ReImagineStyles.rootTwo, { marginTop: 10 }]}>
      <Heading title={getMeaning("HME.GTNTCHHDNG")} />

      <Box align="center">
        <GlobalSubHeading subTitle={getMeaning("HME.CONTACTUSDESCP1")} />
        {/* <Typography
          sx={[
            HomeBannerStyles.bannerDescription,
            { width: { xs: "100%", md: "90%" }, mt: { xs: 1, md: 0 } },
          ]}
        >
          {getMeaning("HME.CONTACTUSDESCP1")}
        </Typography> */}
      </Box>

      <br />

      <Box align="center">
        <GlobalSubHeading subTitle={getMeaning("HME.CONTACTUSDESCP2")} />
        {/* <Typography
          sx={[
            HomeBannerStyles.bannerDescription,
            { width: { xs: "100%", md: "90%" } },
          ]}
        >
          {getMeaning("HME.CONTACTUSDESCP2")}
        </Typography> */}
      </Box>

      <Grid
        mt={3}
        container
        spacing={3}
        alignItems="flex-start"
        justifyContent="space-around"
      >
        <Grid xs={12} sm={5} md={5}>
          <Box
            component="iframe"
            src="https://maps.google.com/maps?q=28.451898635521523, 77.07156363978454&z=15&output=embed"
            width="100%"
            height="100%"
            style={{
              // width: "760px", // Old Code Commented on 10th April
              height: "680px",
              borderRadius: "12px",
              border: "2px solid #D3D3D3",
            }}
            sx={{ width: { xs: "311px", sm: "430px", md: "560px" } }} // New Code Write on 10th April
            allowFullScreen
            loading="lazy"
            title="My Location"
          />
        </Grid>

        <Grid xs={12} sm={7} md={7}>
          <Paper
            elevation={3}
            sx={{
              ...ContactUsStyles.formCard,
              // p: { xs: 2, sm: 3, md: 4 }
            }}
            style={{
              boxShadow: 6,
              borderRadius: 6,
              backgroundColor: "#fff",
              border: "0.6px solid #D3D3D3",
            }}
          >
            <Heading title={getMeaning("HME.GTNTCHHDNG")} />

            <Typography sx={[ContactUsStyles.formSubtext]}>
              {getMeaning("HME.GTNTCHSBHDNG")}
            </Typography>

            <Grid
              container
              spacing={2}
              sx={{ mt: 1 }}
              style={{ width: "100%" }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    sx={{
                      width: { xs: "272px", md: "240px" },
                      fontFamily: '"Poppins", serif',
                    }}
                    variant="outlined"
                    label={getMeaning("HME.FSTNMELBL")}
                    InputProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                    InputLabelProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    sx={{
                      width: { xs: "272px", md: "240px" },
                      fontFamily: '"Poppins", serif',
                    }}
                    variant="outlined"
                    label={getMeaning("HME.LSTNMELBL")}
                    InputProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                    InputLabelProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    sx={{
                      width: { xs: "272px", md: "240px" },
                      fontFamily: '"Poppins", serif',
                    }}
                    variant="outlined"
                    label={getMeaning("HME.EMLADRSLBL")}
                    InputProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                    InputLabelProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    sx={{
                      width: { xs: "272px", md: "240px" },
                      fontFamily: '"Poppins", serif',
                    }}
                    variant="outlined"
                    label={getMeaning("HME.CMPNYNMELBL")}
                    InputProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                    InputLabelProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    sx={{
                      width: { xs: "272px", md: "240px" },
                      fontFamily: '"Poppins", serif',
                    }}
                    variant="outlined"
                    label={getMeaning("HME.INDSTRYLBL")}
                    InputProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                    InputLabelProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    sx={{
                      width: { xs: "272px", md: "240px" },
                      fontFamily: '"Poppins", serif',
                    }}
                    variant="outlined"
                    label={getMeaning("HME.PHNELBL")}
                    InputProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                    InputLabelProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                  />
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                // style={{ width: "97%" }}
              >
                <TextField
                  fullWidth
                  multiline
                  variant="outlined"
                  label={getMeaning("HME.YRMSGLBL")}
                  sx={{
                    fontFamily: '"Poppins", serif',
                    minHeight: 150,
                    width: { xs: "272px", md: "495px" },
                    "& .MuiInputBase-root": {
                      alignItems: "center",
                      height: "100%",
                      minHeight: 150,
                    },
                    "& .MuiInputBase-inputMultiline": {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      paddingTop: "auto",
                      paddingBottom: "auto",
                      fontFamily: '"Poppins", serif',
                    },
                  }}
                  InputLabelProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                />
              </Grid>
            </Grid>

            <Typography sx={ContactUsStyles.privacyText}>
              {getMeaning("HME.PRVCYPLCY")}
              <Box component="span" sx={ContactUsStyles.privacyLink}>
                {getMeaning("HME.PRVCYPLCY2")}
              </Box>
              {getMeaning("HME.PRVCYPLCYDSCP")}
            </Typography>

            <Button
              variant="contained"
              fullWidth={isSm}
              sx={ContactUsStyles.submitButton}
            >
              {getMeaning("HME.SNDMSGBTN")}
            </Button>
          </Paper>
        </Grid>
      </Grid>

      {/* <Grid
        mt={3}
        container
        spacing={3}
        alignItems="stretch"
        justifyContent="space-around"
      >
        {/* Google Maps 
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              height: { xs: 400, sm: formHeight }, // responsive for small screens
              borderRadius: "12px",
              border: "2px solid #D3D3D3",
              overflow: "hidden",
            }}
          >
            <Box
              component="iframe"
              src="https://maps.google.com/maps?q=28.451898635521523,77.07156363978454&z=15&output=embed"
              width="100%"
              height="100%"
              style={{
                border: 0,
              }}
              allowFullScreen
              loading="lazy"
              title="My Location"
            />
          </Box>
        </Grid>

        {/* Contact Form 
        <Grid item xs={12} md={6}>
          <Paper
            ref={formRef}
            elevation={3}
            sx={{
              ...ContactUsStyles.formCard,
              p: { xs: 2, sm: 3, md: 4 },
              width: "100%",
              borderRadius: 6,
              backgroundColor: "#fff",
              border: "0.6px solid #D3D3D3",
            }}
          >
            <Heading title={getMeaning("HME.GTNTCHHDNG")} />

            <Typography sx={ContactUsStyles.formSubtext}>
              {getMeaning("HME.GTNTCHSBHDNG")}
            </Typography>

            <Grid container spacing={2} sx={{ mt: 1 }}>
              {[
                { label: "HME.FSTNMELBL" },
                { label: "HME.LSTNMELBL" },
                { label: "HME.EMLADRSLBL" },
                { label: "HME.CMPNYNMELBL" },
                { label: "HME.INDSTRYLBL" },
                { label: "HME.PHNELBL" },
              ].map((field, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label={getMeaning(field.label)}
                    sx={{ fontFamily: '"Poppins", serif' }}
                    InputProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                    InputLabelProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                  />
                </Grid>
              ))}

              {/* Message 
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  minRows={4}
                  variant="outlined"
                  label={getMeaning("HME.YRMSGLBL")}
                  sx={{
                    fontFamily: '"Poppins", serif',
                    "& .MuiInputBase-inputMultiline": {
                      fontFamily: '"Poppins", serif',
                    },
                  }}
                  InputLabelProps={{ sx: { fontFamily: '"Poppins", serif' } }}
                />
              </Grid>
            </Grid>

            {/* Privacy Text 
            <Typography sx={ContactUsStyles.privacyText}>
              {getMeaning("HME.PRVCYPLCY")}
              <Box component="span" sx={ContactUsStyles.privacyLink}>
                {getMeaning("HME.PRVCYPLCY2")}
              </Box>
              {getMeaning("HME.PRVCYPLCYDSCP")}
            </Typography>

            {/* Submit Button 
            <Button
              variant="contained"
              fullWidth={isSm}
              sx={ContactUsStyles.submitButton}
            >
              {getMeaning("HME.SNDMSGBTN")}
            </Button>
          </Paper>
        </Grid>
                </Grid> */}
    </Box>
  );
};

export default ContactUs;
